import styled from 'styled-components';

export const Button = styled.button`
  background: black;
  border: none;
`;

export const Container = styled.div`
  position: absolute;
  top: 30px;
  @media screen and (min-width: 501px) {
    right: 30px;
  }
  @media screen and (max-width: 500px) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
